import units from "utils/units"
import metricUrl from "./static/metric.svg"
import imperialUrl from "./static/imperial.svg"

function switchUnits(container: Element) {
  const url = units.length === "Metric" ? metricUrl : imperialUrl

  container.querySelectorAll(".surfscale").forEach((item) => {
    const img = item as HTMLImageElement
    img.src = url
  })

  container.querySelectorAll(".surfscalebg").forEach((item) => {
    const el = item as HTMLElement
    el.style.backgroundImage = `url(${url})`
  })
}

export default function init(container: Element) {
  switchUnits(container)
  units.onChange(() => switchUnits(container))
}
